import { render, staticRenderFns } from "./PeriodsInput.vue?vue&type=template&id=4ae5ef52&scoped=true"
import script from "./PeriodsInput.vue?vue&type=script&lang=ts"
export * from "./PeriodsInput.vue?vue&type=script&lang=ts"
import style0 from "./PeriodsInput.vue?vue&type=style&index=0&id=4ae5ef52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae5ef52",
  null
  
)

export default component.exports